import React from "react";

const Checkbox = ({ label, keyField, formik, required = false, hideRequired = false,readOnly = false, checked, onChange: propsOnChange, ...props }) => {
  const formikValue = formik.values[keyField];
  
  const checkboxValue = formikValue !== undefined && formikValue !== null
    ? Boolean(formikValue)
    : (checked !== undefined ? Boolean(checked) : false);
  
  const fieldProps = formik.getFieldProps(keyField);
  
  const handleChange = (e) => {
    const newValue = e.target.checked;
    formik.setFieldValue(keyField, newValue, false);
    if (propsOnChange) {
      propsOnChange(e);
    }
  };
  
  return (
    <div>
      <div className="customCheckBox">
        <label htmlFor={keyField}>
          {label}
          {hideRequired ? null : required ? <span style={{ color: "red" }}> *</span> : " (Optional)"}
        </label>
        <input
          type="checkbox"
          id={keyField}
          name={keyField}
          checked={checkboxValue}
          onChange={handleChange}
          onBlur={fieldProps.onBlur}
          style={{ width: "24px", height: "24px", }}
          disabled={readOnly}
          {...props}
        />
      </div>
      <div>
        {formik?.touched[keyField] && formik?.errors[keyField] ? (
          <div className="error-text">{formik?.errors[keyField]}</div>
        ) : null}
      </div>
    </div>
  );
};

export default Checkbox;
